<template>
<div class="collapse-item-content"
    :class="{ 'active': currentItemIndex === thisIndex }">
    <div class="image">
        <img :src="thisImage.url || '/svg/image_placeholder.svg'" alt="thisImage.alt || ''">
    </div>
    <div class="text" v-html="text"></div>
</div>  
</template>

<script>
export default {
    props: {
        index: String,
        image: String,
        text: String,
    },
    data() {
        return {
            currentItemIndex: 0,
            thisIndex: parseInt(this.index),
            thisImage: JSON.parse(this.image),
        };
    },
    mounted() {
        this.$eventHub.$on('updateTabItemIndex', (index) => {
            this.currentItemIndex = index;
        });
    }
}
</script>
